export default (settings, module_name) => {
  const productsContainer = document.querySelector('[data-content-container]');
  const products = productsContainer.innerHTML;
  const html = `
    <div class="Module-${module_name}__Content">
      <div class="Module-${module_name}__Products" data-cms-product-slider>
        ${products}
      </div>
    </div>
  `;
  return html;
};
